import { Bop as BopDomain,mapBopDto } from '@/domain/models';
import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import language from "@/i18n";
import Bop from "@/models/Bop"; // legacy typing (keep until full migration)
import { AxiosPromise,AxiosResponse } from 'axios';
const rootPath = "bops";

export type GeneratePdfDto = {
  bopLink: string;
  languageCode: string;
};
class BopService {
  // public getTableUrl(lang:string): string {
  //     return `${apiProvider.getUrl()}${rootPath}${toUrl({lang: lang})}`;
  // }

  private getBop(bopId: string): AxiosPromise {
    return apiClient.get(`${rootPath}/${bopId}${buildQuery({ lang: language.locale })}`);
  }
  // Domain-mapped variant (accepts UUID or numeric BOP number)
  public async getBopDomain(bopIdOrNumber: string): Promise<BopDomain> {
    const isNumeric = /^\d+$/.test(bopIdOrNumber);
    const res = isNumeric
      ? await this.getBopByNumber(bopIdOrNumber)
      : await this.getBop(bopIdOrNumber);
    return mapBopDto(res.data);
  }
  private getBopByNumber(bopNumber: string): AxiosPromise {
    return apiClient.get(`${rootPath}/byNumber/${bopNumber}${buildQuery({ lang: language.locale })}`);
  }
  public getCurrrentTotalPoint(bopId: string): AxiosPromise {
    return apiClient.get(`${rootPath}/currenttotal/${bopId}${buildQuery({ lang: language.locale })}`);
  }
  public getBopOperationGroups(
    bopId: string,
    operationType: number,
    lang: string
  ): AxiosPromise {
    return apiClient.get(`${rootPath}/${bopId}/operationGroups${buildQuery({ operationType, lang })}`);
  }
  public getSubBopOperationGroups(
    subBopId: string,
    operationType: number,
    lang: string
  ): AxiosPromise {
    return apiClient.get(`${rootPath}/${subBopId}/operationGroupsBySubBop${buildQuery({ operationType, lang })}`);
  }
  public save(
    bop: Bop,
    canBeEditedAfterRealised: boolean = false,
    action?: string
  ): AxiosPromise {
    return apiClient.put(`${rootPath}/${bop.id}${buildQuery({
      canBeEditedAfterRealised,
      lang: language.locale,
      action,
    })}`, bop);
  }

  public getAllBopUrl(lang: string, filter:string, statuses:string, bopModel:string, startDate:string, endDate:string, hiddenColumns:string = ''): string {
    return `${apiClient.defaults.baseURL || ''}${rootPath}/all/${lang}${buildQuery({filter, statuses, bopModel, startDate, endDate, hiddenColumns})}`;
  }

  public async getAllBop(lang: string): Promise<any> {
    return apiClient.get(this.getAllBopUrl(lang, "", "","","",""));
  }

  public async setBopToInitialState(bopId: string): Promise<any> {
    return apiClient.patch(`${rootPath}/${bopId}/setInitialState`);
  }
  public userHaveAccess(bopIdOrNumber: string): Promise<any> {
    return apiClient.get(`${rootPath}/userHaveAccess/${bopIdOrNumber}`);
  }

  public cancelBop(bopId: string): Promise<any> {
    return apiClient.post(`${rootPath}/cancelBop`, JSON.stringify(bopId));
  }

  public mailDismantleBop(bopId: string): Promise<any> {
    return apiClient.post(`${rootPath}/mailDismantleBop${buildQuery({
      lang: language.locale,
    })}`, JSON.stringify(bopId));
  }

  public generatePdf(
    generatePdfDto: GeneratePdfDto,
    bopId: string
  ): Promise<AxiosResponse<any>> {
    return apiClient.post(`${rootPath}/generate-pdf/${bopId}`, generatePdfDto);
  }

  public downloadPdf(
    bopId: string,
    generatePdfDto: GeneratePdfDto
  ): Promise<AxiosResponse<any>> {
    return apiClient.post(`${rootPath}/download-bop-pdf/${bopId}`, generatePdfDto, { responseType: "blob" });
  }

  public updateSummaryComment(bopId: string, summaryComment: string): Promise<AxiosResponse<any>> {
    return apiClient.patch(
      `${rootPath}/${bopId}/summary-comment`,
      JSON.stringify(summaryComment),
      { 
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }

  public patchDismantleDate(febId: string, newDate: Date): Promise<AxiosResponse<any>> {
    return apiClient.patch(
      `${rootPath}/feb-dismantle-date/${febId}`,
      JSON.stringify(newDate),
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }
}

export default new BopService();
